// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState, useEffect } from "react";
import Header from "../../component/_elements/Header.tsx";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType.ts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { login as loginAPI } from "../../_api/auth.js";

import {
  PaiementType,
  paymentController,
} from "../../_api/controllers/payment.controller.ts";
import {
  classeController,
  motifPaiementController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import moment from "moment";
import { useAuth } from "../../_api/auth.js";
import toast from "react-hot-toast";

const Payment: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClass, setSelectedClass] = useState("Toutes les classes");
  const [selectedStatus, setSelectedStatus] = useState("Tous les statuts");
  const [selectedDate, setSelectedDate] = useState("Toutes les dates");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [isClassDropdownOpen, setIsClassDropdownOpen] = useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState<any>(null);

  const [selectedPayment, setSelectedPayment] = useState<any>(null);

  const [createPaymentForm, setcreatePaymentForm] = useState<{
    date: string;
    amount: any;
    type: any;
    method: string;
    status: any;
    selectedStudentId: any;
    isCreation: boolean;
  }>({
    date: "",
    amount: "",
    type: 1,
    method: "Carte",
    status: 1,
    selectedStudentId: "",
    isCreation: false,
  });

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [notification, setNotification] = useState<any>(null); // { message, type }

  // Fonction pour afficher une notification
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  // connected user
  const { user } = useAuth();

  const queryClient = useQueryClient();

  const mutationUpdatePayment = useMutation({
    mutationFn: () =>
      paymentController.update(selectedPayment.id, {
        montant: selectedPayment.montant,
        jour: moment().format("YYYY-MM-DD HH:mm:ss"),
        motif_paiement_id: selectedPayment.motif_paiement_id,
        eleve_id: selectedPayment.eleve_id,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: selectedPayment.annee_scolaire_id,
        operation_id: `INV-${moment().year()}-00${moment().format(
          "DDMMYYYYHHMMSS"
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),

    onSuccess: (data) => {
      setShowEditModal(false);
      showNotification("Modifications enregistrées avec succès", "success");
      setSelectedPayment(null);
      setShowPasswordModal(false);
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer....", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationLogin = useMutation({
    mutationFn: loginAPI,
    onSuccess: (data) => {
      if (data.token) {
        //after password correct call apdate function mutation
        if (createPaymentForm.isCreation) {
          mutationCreatePayment.mutate();
        } else {
          mutationUpdatePayment.mutate();
        }
      } else
        return toast.error("Mot de passe incorrect, veuillez réessayer.", {
          duration: 4000,
          position: "bottom-right",
          style: {
            background: "red",
            color: "#fff",
            padding: "10px",
            fontSize: "14px",
            borderRadius: "5px",
          },
        });
    },

    onError: (error) => {
      console.log(error);
      return;
    },
  });

  //update save new payement
  const mutationCreatePayment = useMutation({
    mutationFn: () =>
      paymentController.create({
        montant: createPaymentForm.amount,
        jour: moment().format("YYYY-MM-DD HH:mm:ss"),
        motif_paiement_id: 1,
        // motif_paiement_id: createPaymentForm.type,
        eleve_id: createPaymentForm.selectedStudentId,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: schoolYearActiveData?.data[0].id,
        operation_id: `INV-${moment().year()}-00${moment().format(
          "DDMMYYYYHHMMSS"
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),
    onSuccess: (data) => {
      console.log("===========");
      console.log(data);
      setShowPasswordModal(false);
      showNotification(" Nouveau paiement effectué avec succès!", "success");
      setcreatePaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        selectedStudentId: "",
        isCreation: false,
      });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      console.log("===========");
      console.log(err);
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
      setcreatePaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        selectedStudentId: "",
        isCreation: false,
      });
    },
  });

  const mutationAnnulerPayment = useMutation({
    mutationFn: () => paymentController.desactivate(paymentToDelete.id),
    onSuccess: (data) => {
      // console.log("desactivate Mutation", data);
      setShowDeleteModal(false);
      showNotification(" Annulation effectuée avec succès!", "success");

      setPaymentToDelete(null);
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      console.log(err);
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  // Étape 1 : ouverture du modal de confirmation
  const handleOpenConfim = () => {
    setShowPasswordModal(true);
  };

  // function to cancel payment
  const handleAnnulerPayement = () => {
    mutationAnnulerPayment.mutate();
  };

  // Étape 2 : vérification du mot de passe
  const handleConfirmByPassword = () => {
    if (!password)
      return showNotification("Veuillez compléter le mot de passe", "error");
    if (!user.email)
      return showNotification("Une erreur s'est produite, actualiser", "error");
    //call the login & update mutation functions
    mutationLogin.mutate({ email: user.email, password });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const dropdown = document.getElementById("export-dropdown");
      const button = document.getElementById("export-button");
      if (
        dropdown &&
        button &&
        !button.contains(event.target as Node) &&
        !dropdown.contains(event.target as Node)
      ) {
        dropdown.style.display = "none";
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // console.log(paymentAmount);
  const [currentPage, setCurrentPage] = useState(1);
  const paymentsPerPage = 100;

  const handleReceiptClick = (payment: any) => {
    setSelectedPayment(payment);
    setShowReceiptModal(true);
  };

  const generateReferenceNumber = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const random = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, "0");
    return `PAY-${year}${month}-${random}`;
  };
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const toggleClassDropdown = () => {
    setIsClassDropdownOpen(!isClassDropdownOpen);
    if (isClassDropdownOpen) {
      setIsStatusDropdownOpen(false);
      setIsDateDropdownOpen(false);
    }
  };
  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
    if (isStatusDropdownOpen) {
      setIsClassDropdownOpen(false);
      setIsDateDropdownOpen(false);
    }
  };
  const toggleDateDropdown = () => {
    setIsDateDropdownOpen(!isDateDropdownOpen);
    if (isDateDropdownOpen) {
      setIsClassDropdownOpen(false);
      setIsStatusDropdownOpen(false);
    }
  };

  //

  //fetch all students
  const { data: studentdata } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });
  //fetch all payment data
  const { data: paiementData } = useQuery({
    queryKey: ["payments"],
    queryFn: paymentController.getAll,
  });

  const { data: promotionData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });
  const { data: classeData } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });
  const { data: schoolYearActiveData } = useQuery({
    queryKey: ["activeSchoolYears"],
    queryFn: schoolYearController.getActive,
  });
  // fetch motif Paiement
  const { data: motifPaiementData } = useQuery({
    queryKey: ["motifPaiement"],
    queryFn: motifPaiementController.getAll,
  });

  const classeDataArr = classeData?.data ? classeData?.data : [];
  const schoolYearActiveDataArr = schoolYearActiveData?.data
    ? schoolYearActiveData?.data
    : [];
  const promotionDataArr = promotionData?.data ? promotionData?.data : [];
  const paymentDataArray = paiementData?.data ? paiementData.data : [];
  const studentDataArr = studentdata?.data ? studentdata.data : [];
  const motifPaiementArr = motifPaiementData?.data
    ? motifPaiementData.data
    : [];

  //Filter payement of active schoolYear
  let paymentForActiveYear = paymentDataArray.filter(
    (payment) => payment.annee_scolaire_id === schoolYearActiveDataArr[0]?.id
  );

  //Create explicite dataArray for students
  let completePayementsArray: PaiementType &
    any &
    {
      eleve: string;
      type: string;
      classe: string;
      montant: any;
      date: string;
      statut: string;
      methode: string;
      id: any;
    }[] = paymentForActiveYear.map((payment: PaiementType) => {
    let student_data: any,
      promotion_data: any,
      class_data: any,
      motif_designation: any;

    for (const student of studentDataArr) {
      if (student.eleve_id === payment.eleve_id) {
        student_data = student;
      }
    }
    for (const motif of motifPaiementArr) {
      if (motif.id === payment.motif_paiement_id) {
        motif_designation = motif.designation;
      }
    }

    for (const promotion of promotionDataArr) {
      if (
        promotion.annee_scolaire_id === schoolYearActiveData?.data[0].id &&
        promotion.eleve_id === payment.eleve_id
      ) {
        promotion_data = promotion;
        //it is possible to get all promotion of the current student here by handling the condition above
      }
    }

    for (const classe of classeDataArr) {
      if (promotion_data?.classe_id === classe.id) {
        class_data = classe.designation;
      }
    }

    return {
      ...payment,
      eleve: `${student_data?.nom} ${
        student_data?.postnom
      } ${capitalizeFirstLetter(student_data?.prenom)}`,
      classe: capitalizeFirstLetter(class_data),
      promotionData: promotionData,
      type: motif_designation,
      methode: "Espèce", //default value for methode
      statut: payment.status ? "Payé" : "Annulé", //default value for statut
      date: moment(payment.created_at).format("DD/MM/YYYY"),
    };
  });

  // console.log(completePayementsArray);
  const payments = [...completePayementsArray];

  // Filtrer les paiements selon la recherche et les filtres
  const filteredPayments = payments.filter((payment) => {
    const matchesSearch =
      payment.eleve.toLowerCase().includes(searchQuery.toLowerCase()) ||
      payment.type.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesClass =
      selectedClass === "Toutes les classes" ||
      payment.classe.toLocaleLowerCase() === selectedClass.toLowerCase();
    const matchesStatus =
      selectedStatus === "Tous les statuts" ||
      payment.statut === selectedStatus;

    const matchesDate =
      selectedDate === "Toutes les dates" ||
      payment.date.includes(selectedDate);
    const matchesAmount =
      !selectedAmount ||
      payment.montant.replace(/[^0-9,]/g, "") ===
        selectedAmount.replace(/[^0-9,]/g, "");
    return (
      matchesSearch &&
      matchesClass &&
      matchesStatus &&
      matchesDate &&
      matchesAmount
    );
  });

  const indexOfLastPayment = currentPage * paymentsPerPage;
  const indexOfFirstPayment = indexOfLastPayment - paymentsPerPage;
  const currentPayments = filteredPayments.slice(
    indexOfFirstPayment,
    indexOfLastPayment
  );
  const totalPages = Math.ceil(filteredPayments.length / paymentsPerPage);
  const handlePageChange = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleChangeDate = (e: any) => {
    const selectedDateValue = e.target.value;
    if (selectedDateValue) {
      setSelectedDate(moment(selectedDateValue).format("DD/MM/YYYY"));
      setIsDateDropdownOpen(false);
    }
  };

  const handleResetFilter = () => {
    setSelectedClass("Toutes les classes");
    setSelectedStatus("Tous les statuts");
    setSelectedDate("Toutes les dates");
  };

  //Handle mouse click outside for dropdowns
  const dateDropdownRef = React.useRef<HTMLDivElement>(null);
  const classDropdownRef = React.useRef<HTMLDivElement>(null);
  const statusDropdownRef = React.useRef<HTMLDivElement>(null);
  // Fermeture des menus lors d'un clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target as Node)
      ) {
        setIsDateDropdownOpen(false);
      }

      //class button
      if (
        classDropdownRef.current &&
        !classDropdownRef.current.contains(event.target as Node)
      ) {
        setIsClassDropdownOpen(false);
      }

      //status button
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsStatusDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />
      {/* Payments Management Content */}
      <main className="p-6 mt-16">
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold mb-1">Gestion des paiements</h1>
            <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              Gérez les transactions financières et générez des reçus
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowAddModal(true)}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-500 hover:bg-blue-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-plus-circle mr-2"></i>
              <span>Nouveau paiement</span>
            </button>

            <div className="relative">
              <button
                id="export-button"
                onClick={() => {
                  const dropdown = document.getElementById("export-dropdown");
                  if (dropdown) {
                    dropdown.style.display =
                      dropdown.style.display === "none" ? "block" : "none";
                  }
                }}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-gray-100 hover:bg-gray-200"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-file-export mr-2"></i>
                <span>Exporter</span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              <div
                id="export-dropdown"
                className={`absolute right-0 mt-2 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } ring-1 ring-black ring-opacity-5 z-50`}
                style={{ display: "none" }}
              >
                <div className="py-1">
                  {/* <button
                    onClick={() => {
                      const dropdown =
                        document.getElementById("export-dropdown");
                      if (dropdown) {
                        dropdown.style.display = "none";
                      }
                      // Convert filtered payments to Excel format
                      const data = filteredPayments.map((payment) => ({
                        Élève: payment.eleve,
                        Classe: payment.classe,
                        Montant: payment.montant,
                        Date: payment.date,
                        Type: payment.type,
                        Statut: payment.statut,
                        Méthode: payment.methode,
                      }));
                      // Create CSV content
                      const headers = Object.keys(data[0]);
                      const csvContent = [
                        headers.join(","),
                        ...data.map((row: any) =>
                          headers.map((header) => `"${row[header]}"`).join(",")
                        ),
                      ].join("\n");
                      // Create and trigger download
                      const blob = new Blob([csvContent], {
                        type: "text/csv;charset=utf-8;",
                      });
                      const link = document.createElement("a");
                      link.href = URL.createObjectURL(blob);
                      link.download = `paiements_${
                        new Date().toISOString().split("T")[0]
                      }.csv`;
                      link.click();
                      // Show success notification
                      const notification = document.createElement("div");
                      notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white ${
                        isDarkMode ? "bg-green-600" : "bg-green-500"
                      } shadow-lg transition-opacity duration-500`;
                      notification.innerHTML =
                        '<i class="fas fa-check-circle mr-2"></i>Export CSV réussi';
                      document.body.appendChild(notification);
                      setTimeout(() => {
                        notification.style.opacity = "0";
                        setTimeout(() => notification.remove(), 500);
                      }, 3000);
                    }}
                    className={`block w-full text-left px-4 py-2 text-sm ${
                      isDarkMode
                        ? "text-gray-300 hover:bg-gray-700"
                        : "text-gray-700 hover:bg-gray-100"
                    } cursor-pointer`}
                  >
                    <i className="fas fa-file-csv mr-2"></i>
                    Exporter en CSV
                  </button> */}
                  <button
                    onClick={() => {
                      const dropdown =
                        document.getElementById("export-dropdown");
                      if (dropdown) {
                        dropdown.style.display = "none";
                      }
                      // Convert filtered payments to Excel format
                      const data = filteredPayments.map((payment) => ({
                        Élève: payment.eleve,
                        Classe: payment.classe,
                        Montant: payment.montant,
                        Date: payment.date,
                        Type: payment.type,
                        Statut: payment.statut,
                        // Méthode: payment.methode,
                      }));
                      // Create Excel-like content
                      const headers = Object.keys(data[0]);
                      const excelContent = [
                        headers.join("\t"),
                        ...data.map((row: any) =>
                          headers.map((header) => row[header]).join("\t")
                        ),
                      ].join("\n");
                      // Create and trigger download
                      const blob = new Blob([excelContent], {
                        type: "text/tab-separated-values;charset=utf-8;",
                      });
                      const link = document.createElement("a");
                      link.href = URL.createObjectURL(blob);
                      link.download = `paiements_${
                        new Date().toISOString().split("T")[0]
                      }.xls`;
                      link.click();
                      // Show success notification
                      const notification = document.createElement("div");
                      notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white ${
                        isDarkMode ? "bg-green-600" : "bg-green-500"
                      } shadow-lg transition-opacity duration-500`;
                      notification.innerHTML =
                        '<i class="fas fa-check-circle mr-2"></i>Export Excel réussi';
                      document.body.appendChild(notification);
                      setTimeout(() => {
                        notification.style.opacity = "0";
                        setTimeout(() => notification.remove(), 500);
                      }, 3000);
                    }}
                    className={`block w-full text-left px-4 py-2 text-sm ${
                      isDarkMode
                        ? "text-gray-300 hover:bg-gray-700"
                        : "text-gray-700 hover:bg-gray-100"
                    } cursor-pointer`}
                  >
                    <i className="fas fa-file-excel mr-2"></i>
                    Exporter en Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex-grow relative">
            <div
              className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
            >
              <i className="fas fa-search"></i>
            </div>
            <input
              type="text"
              placeholder="Rechercher un paiement..."
              className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                isDarkMode
                  ? "bg-[#161B22] border-gray-700"
                  : "bg-white border-gray-300"
              } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          {/* Date Filter */}
          <div className="relative">
            <button
              onClick={toggleDateDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedDate}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isDateDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-56 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={dateDropdownRef}
              >
                <div className="py-1 space-y-2 p-2">
                  <button
                    onClick={() => {
                      setSelectedDate("Toutes les dates");
                      setIsDateDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Toutes les dates
                  </button>
                  <input
                    type="date"
                    onChange={handleChangeDate}
                    // onClick={handleChangeDate}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode
                        ? "bg-gray-700 hover:bg-gray-800"
                        : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  />
                </div>
              </div>
            )}
          </div>
          {/* Class Filter */}
          <div className="relative">
            <button
              onClick={toggleClassDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedClass}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isClassDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={classDropdownRef}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedClass("Toutes les classes");
                      setIsClassDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Toutes les classes
                  </button>

                  {classeDataArr.map((classe) => (
                    <button
                      key={classe.id}
                      onClick={() => {
                        setSelectedClass(classe.designation);
                        setIsClassDropdownOpen(false);
                      }}
                      className={`block px-4 py-2 text-sm w-full text-left ${
                        isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                      } !rounded-button whitespace-nowrap`}
                    >
                      {capitalizeFirstLetter(classe.designation)}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Status Filter */}
          <div className="relative">
            <button
              onClick={toggleStatusDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedStatus}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isStatusDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={statusDropdownRef}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedStatus("Tous les statuts");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous les statuts
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus("Payé");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Payé
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus("Annulé");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Annulé
                  </button>
                  {/* <button
                    onClick={() => {
                      setSelectedStatus("En retard");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    En retard
                  </button> */}
                </div>
              </div>
            )}
          </div>
          {/* Filter Button */}
          <button
            className={`px-4 py-2 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
            title="Reinitialiser"
            onClick={handleResetFilter}
          >
            <i className="fas fa-filter"></i>
          </button>
        </div>
        {/* Payments Table */}
        <div
          className={`rounded-lg overflow-hidden border ${
            isDarkMode ? "border-gray-700" : "border-gray-300"
          }`}
        >
          <table className="min-w-full divide-y divide-gray-700">
            <thead className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}>
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Élève
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Montant
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Date
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Type de frais
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                >
                  Statut
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody
              className={`${
                isDarkMode ? "bg-[#0D1117]" : "bg-white"
              } divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}
            >
              {currentPayments.map((payment) => (
                <tr
                  key={payment.id}
                  className={`${
                    isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div
                      className={`${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      } font-medium text-sm`}
                    >
                      {payment.eleve}
                    </div>
                    <div
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      {payment.classe}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap font-medium">
                    {payment.montant} {" $"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {payment.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {payment.type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        payment.statut === "Payé"
                          ? "bg-green-100 text-green-800"
                          : payment.statut === "En attente"
                          ? "bg-yellow-100 text-yellow-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {payment.statut}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="flex justify-center space-x-3">
                      <button
                        onClick={() => handleReceiptClick(payment)}
                        className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                        title="Détail"
                      >
                        <i className="fas fa-receipt"></i>
                      </button>
                      <button
                        onClick={() => {
                          setSelectedPayment(payment);
                          setShowEditModal(true);
                        }}
                        className={`${
                          !payment.status
                            ? "cursor-not-allowed text-gray-400"
                            : "cursor-pointer text-green-500 hover:text-green-700"
                        } !rounded-button whitespace-nowrap`}
                        title="Modifier"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        onClick={() => {
                          setPaymentToDelete(payment);
                          setShowDeleteModal(true);
                        }}
                        className={`${
                          !payment.status
                            ? "text-gray-400 cursor-not-allowed"
                            : "text-red-500 hover:text-red-700 cursor-pointer"
                        }  !rounded-button whitespace-nowrap`}
                        title="Annuler"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
          <div
            className={`text-sm ${
              isDarkMode ? "text-gray-400" : "text-gray-600"
            }`}
          >
            Affichage de {indexOfFirstPayment + 1} à{" "}
            {Math.min(indexOfLastPayment, filteredPayments.length)} sur{" "}
            {filteredPayments.length} paiements
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={`px-3 py-1 rounded-md ${
                  currentPage === index + 1
                    ? `${isDarkMode ? "bg-blue-600" : "bg-blue-500"} text-white`
                    : `${
                        isDarkMode
                          ? "bg-[#161B22] hover:bg-gray-700"
                          : "bg-white hover:bg-gray-100"
                      } border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      }`
                } !rounded-button whitespace-nowrap`}
              >
                {index + 1}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === totalPages
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </main>

      {/* Receipt Modal */}
      {showReceiptModal && selectedPayment && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-2xl rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-bold">Reçu de paiement</h3>
              <button
                onClick={() => setShowReceiptModal(false)}
                className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="p-6" id="receipt-content">
              <div className="mb-6 text-center">
                <h2 className="text-2xl font-bold mb-2">ChikSoft</h2>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Reçu de paiement scolaire
                </p>
              </div>
              <div
                className={`mb-6 p-4 rounded-lg ${
                  isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
                }`}
              >
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Numéro de référence
                    </p>
                    <p className="font-medium">
                      {selectedPayment?.operation_id}
                    </p>
                  </div>
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Date
                    </p>
                    <p className="font-medium">{selectedPayment.date}</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Élève
                    </p>
                    <p className="font-medium">{selectedPayment.eleve}</p>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      {selectedPayment.classe}
                    </p>
                  </div>
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Montant payé ($)
                    </p>
                    <p className="font-medium text-xl">
                      {selectedPayment.montant}
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Type de paiement
                    </p>
                    <p className="font-medium">{selectedPayment.type}</p>
                  </div>
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Méthode de paiement
                    </p>
                    <p className="font-medium">{selectedPayment.methode}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between`}
            >
              <div className="flex space-x-3">
                {/* <button
                  id="print-receipt-btn"
                  onClick={() => {
                    // setShowReceiptModal(true);
                    const printContent =
                      document.getElementById("receipt-content");
                    const originalContent = document.body.innerHTML;
                    if (printContent) {
                      document.body.innerHTML = printContent.innerHTML;
                      window.print();
                      document.body.innerHTML = originalContent;
                      // Re-render React app after printing
                      const root = document.getElementById("root");
                      if (root) {
                        root.style.display = "block";
                      }
                    }
                  }}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-100 hover:bg-gray-200"
                  } !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-print mr-2"></i>
                  Imprimer
                </button> */}
                {/* <button
                  onClick={() => setShowReceiptModal(false)}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-100 hover:bg-gray-200"
                  } !rounded-button whitespace-nowrap`}
                >
                  <i className="fas fa-times mr-2"></i>
                  Fermer
                </button> */}
              </div>
              <button
                onClick={() => setShowReceiptModal(false)}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-red-500 hover:bg-red-600"
                } text-white !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-times mr-2"></i>
                {"Fermer"}
              </button>
            </div>
            <div
              id="email-form"
              className="p-6 border-t border-gray-700"
              style={{ display: "none" }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const emailForm = document.getElementById("email-form");
                  if (emailForm) {
                    emailForm.style.display = "none";
                  }
                  // Show success notification
                  const notification = document.createElement("div");
                  notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white ${
                    isDarkMode ? "bg-green-600" : "bg-green-500"
                  } shadow-lg transition-opacity duration-500`;
                  notification.innerHTML =
                    '<i class="fas fa-check-circle mr-2"></i>Email envoyé avec succès';
                  document.body.appendChild(notification);
                  setTimeout(() => {
                    notification.style.opacity = "0";
                    setTimeout(() => notification.remove(), 500);
                  }, 3000);
                }}
              >
                <div className="space-y-4">
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Email du destinataire
                    </label>
                    <input
                      type="email"
                      defaultValue="parent@email.com"
                      required
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Objet
                    </label>
                    <input
                      type="text"
                      defaultValue={`Reçu de paiement - ${selectedPayment?.type}`}
                      required
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Message
                    </label>
                    <textarea
                      defaultValue={`Bonjour,\n\nVeuillez trouver ci-joint le reçu de paiement pour ${selectedPayment?.type} de ${selectedPayment?.eleve}.\n\nCordialement,\nEduGest`}
                      required
                      rows={4}
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                </div>
                <div className="mt-4 flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => {
                      const emailForm = document.getElementById("email-form");
                      if (emailForm) {
                        emailForm.style.display = "none";
                      }
                    }}
                    className={`px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Annuler
                  </button>
                  <button
                    type="submit"
                    className={`px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white !rounded-button whitespace-nowrap`}
                  >
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Edit Payment Modal */}
      {showEditModal && selectedPayment && (
        <>
          {/* ===== MODAL PRINCIPALE ===== */}
          <div
            data-edit-modal
            className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4"
          >
            <div
              className={`relative w-full max-w-2xl rounded-lg shadow-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-white"
              }`}
            >
              {/* Header */}
              <div
                className={`p-4 border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <h3 className="text-xl font-bold">Modifier le paiement</h3>
                <button
                  onClick={() => setShowEditModal(false)}
                  className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>

              {/* Body */}
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Montant */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Montant ($)
                    </label>
                    <input
                      type="number"
                      required
                      min="0"
                      step="0.01"
                      value={selectedPayment.montant}
                      onChange={(e) =>
                        setSelectedPayment({
                          ...selectedPayment,
                          montant: Number(e.target.value),
                        })
                      }
                      className={`w-full px-3 py-1 h-[40px] rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      placeholder="0,00"
                    />
                  </div>

                  {/* Type de frais */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Type de frais
                    </label>
                    <div
                      className={`relative border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      } rounded-md`}
                    >
                      <select
                        value={selectedPayment.type}
                        onChange={(e) =>
                          setSelectedPayment({
                            ...selectedPayment,
                            type: e.target.value,
                          })
                        }
                        className={`appearance-none w-full px-3 py-1 h-[40px] rounded-md ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      >
                        <option value="Frais de scolarité">
                          Frais de scolarité
                        </option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>

                  {/* Mode de paiement */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Mode de paiement
                    </label>
                    <div
                      className={`relative border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      } rounded-md`}
                    >
                      <select
                        value={selectedPayment.methode}
                        onChange={(e) =>
                          setSelectedPayment({
                            ...selectedPayment,
                            methode: e.target.value,
                          })
                        }
                        className={`appearance-none w-full px-3 py-1 h-[35px] rounded-md ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      >
                        <option value="Espèces">Espèces</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>

                  {/* Statut */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Statut
                    </label>
                    <div
                      className={`relative border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      } rounded-md`}
                    >
                      <select
                        value={selectedPayment.statut}
                        onChange={(e) =>
                          setSelectedPayment({
                            ...selectedPayment,
                            statut: e.target.value,
                          })
                        }
                        className={`appearance-none w-full h-[35px] px-3 py-1 rounded-md ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      >
                        <option value="Payé">Payé</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div
                className={`p-4 border-t ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-end space-x-3`}
              >
                <button
                  onClick={() => setShowEditModal(false)}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  onClick={() => {
                    handleOpenConfim();
                    setShowEditModal(false);
                  }}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white !rounded-button whitespace-nowrap`}
                >
                  Enregistrer les modifications
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ===== MODAL DE MOT DE PASSE ===== */}
      {showPasswordModal && (
        <div className="fixed inset-0 z-[60] overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-md rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } p-6`}
          >
            <h3
              className={`text-lg font-medium mb-4 ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Confirmation requise
            </h3>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              } mb-4`}
            >
              Veuillez entrer votre mot de passe pour confirmer les
              modifications.
            </p>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full px-3 py-2 rounded-md border ${
                isDarkMode
                  ? "bg-[#0D1117] border-gray-700 text-white"
                  : "bg-white border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4`}
              placeholder="Entrez votre mot de passe"
            />

            <div className="flex justify-end space-x-3">
              <button
                disabled={
                  mutationLogin.isPending || mutationUpdatePayment.isPending
                }
                onClick={() => {
                  setShowPasswordModal(false);
                  setPassword("");
                  setcreatePaymentForm({
                    date: "",
                    amount: "",
                    type: "",
                    method: "Espèce",
                    status: 1,
                    selectedStudentId: "",
                    isCreation: false,
                  });
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  (mutationLogin.isPending ||
                    mutationUpdatePayment.isPending) &&
                  "cursor-not-allowed"
                }`}
              >
                Annuler
              </button>
              <button
                disabled={
                  mutationLogin.isPending || mutationUpdatePayment.isPending
                }
                onClick={handleConfirmByPassword}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap ${
                  (mutationLogin.isPending ||
                    mutationUpdatePayment.isPending) &&
                  "cursor-not-allowed"
                }`}
              >
                {mutationLogin.isPending || mutationUpdatePayment.isPending
                  ? "Connexion..."
                  : "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && paymentToDelete && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-md rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div className="p-6">
              <div className="text-center">
                <div className="w-12 h-12 rounded-full bg-red-100 mx-auto mb-4 flex items-center justify-center">
                  <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                </div>
                <h3 className="text-lg font-medium mb-2">
                  Confirmer l'annulation du paiement
                </h3>
                <div
                  className={`p-4 rounded-lg mb-4 ${
                    isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
                  }`}
                >
                  <p
                    className={`mb-2 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Êtes-vous sûr de vouloir annuler ce paiement de{" "}
                    <span className="font-semibold">
                      {paymentToDelete.montant} {" $"}
                    </span>{" "}
                    ? Cette action est irréversible
                  </p>
                </div>
                <div className="flex justify-center space-x-3">
                  <button
                    disabled={mutationAnnulerPayment.isPending}
                    onClick={() => {
                      setShowDeleteModal(false);
                      setPaymentToDelete(null);
                    }}
                    className={`px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap ${
                      mutationAnnulerPayment.isPending && "cursor-not-allowed"
                    }`}
                  >
                    Annuler
                  </button>
                  <button
                    disabled={mutationAnnulerPayment.isPending}
                    onClick={() => {
                      handleAnnulerPayement();

                      // Show success notification
                      // const notification = document.createElement("div");
                      // notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white bg-green-500 shadow-lg transition-opacity duration-500`;
                      // notification.innerHTML =
                      //   '<i class="fas fa-check-circle mr-2"></i>Paiement supprimé avec succès';
                      // document.body.appendChild(notification);
                      // setTimeout(() => {
                      //   notification.style.opacity = "0";
                      //   setTimeout(() => notification.remove(), 500);
                      // }, 3000);
                    }}
                    className={`px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white !rounded-button whitespace-nowrap ${
                      mutationAnnulerPayment.isPending && "cursor-not-allowed"
                    }`}
                  >
                    {mutationAnnulerPayment.isPending
                      ? "Chargement..."
                      : "Confirmer l'annulation"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Add Payment Modal */}
      {showAddModal && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-2xl rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-bold">Nouveau paiement</h3>
              <button
                onClick={() => setShowAddModal(false)}
                className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Elève
                </label>
                <div
                  className={`relative border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } rounded-md`}
                >
                  <select
                    value={createPaymentForm.selectedStudentId}
                    onChange={(e) =>
                      setcreatePaymentForm({
                        ...createPaymentForm,
                        selectedStudentId: e.target.value,
                      })
                    }
                    className={`appearance-none h-14 max-h-60 overflow-y-auto w-full px-3 py-1 rounded-md  ${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="">Sélectionner un élève</option>
                    {studentDataArr
                      .sort((a, b) => a?.nom.localeCompare(b?.nom))
                      .map((student: any, index) => {
                        let promotionData: any,
                          classeDesignation: any,
                          classeId: any;
                        for (const promotion of promotionDataArr) {
                          if (
                            promotion.annee_scolaire_id ===
                              schoolYearActiveData?.data[0].id &&
                            promotion.eleve_id === student.eleve_id
                          ) {
                            promotionData = promotion;
                            //it is possible to get all promotion of the current student here by handling the condition above
                          }
                        }
                        for (const classe of classeDataArr) {
                          if (promotionData?.classe_id === classe.id) {
                            classeDesignation = classe.designation;
                            classeId = classe.id;
                          }
                        }
                        return (
                          <option
                            key={student.eleve_id}
                            value={student.eleve_id}
                          >
                            {index + 1} -
                            {`${student.nom} ${
                              student.postnom
                            } ${capitalizeFirstLetter(
                              student.prenom
                            )} -- (${capitalizeFirstLetter(
                              classeDesignation
                            )})`}
                          </option>
                        );
                      })}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Montant (€)
                  </label>
                  <input
                    type="number"
                    value={createPaymentForm.amount}
                    onChange={(e) =>
                      setcreatePaymentForm((prev) => ({
                        ...prev,
                        amount: Number(e.target.value),
                      }))
                    }
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="0,00"
                  />
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Type de frais
                  </label>
                  <div
                    className={`relative border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md`}
                  >
                    <select
                      value={createPaymentForm.type}
                      onChange={(e) =>
                        setcreatePaymentForm((prev) => ({
                          ...prev,
                          type: e.target.value,
                        }))
                      }
                      className={`appearance-none w-full px-3 py-1 h-10 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      {/* <option value="">Sélectionner un type</option> */}
                      <option value={1}>Frais de scolarité</option>
                      {/* <option value="Cantine">Cantine</option>
                      <option value="Voyage scolaire">Voyage scolaire</option>
                      <option value="Fournitures">Fournitures</option>
                      <option value="Activités sportives">
                        Activités sportives
                      </option> */}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                      <i className="fas fa-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Mode de paiement
                  </label>
                  <div
                    className={`relative border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md`}
                  >
                    <select
                      value={createPaymentForm.method}
                      onChange={(e) =>
                        setcreatePaymentForm((prev) => ({
                          ...prev,
                          method: e.target.value,
                        }))
                      }
                      className={`appearance-none w-full px-3 py-1 h-10 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="Espèces">Espèce</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                      <i className="fas fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Statut
                  </label>
                  <div
                    className={`relative border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md`}
                  >
                    <select
                      value={createPaymentForm.status}
                      onChange={(e) =>
                        setcreatePaymentForm((prev) => ({
                          ...prev,
                          status: e.target.value,
                        }))
                      }
                      className={`appearance-none w-full px-3 py-1 h-10 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value={1}>Payé</option>
                      {/* <option value="En attente">En attente</option>
                      <option value="En retard">En retard</option> */}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                      <i className="fas fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                onClick={() => setShowAddModal(false)}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  if (!createPaymentForm.amount)
                    return showNotification(
                      "Le montant à payer ne doit pas être nul s'il vous plait",
                      "error"
                    );
                  if (!createPaymentForm.selectedStudentId)
                    return showNotification(
                      "Veuillez selectionner un élève s'il vous plait",
                      "error"
                    );
                  handleOpenConfim();
                  setcreatePaymentForm((prev) => ({
                    ...prev,
                    isCreation: true,
                  }));
                  setShowAddModal(false);
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap`}
              >
                Enregistrer le paiement
              </button>
            </div>
            <div
              id="email-form"
              className="p-6 border-t border-gray-700"
              style={{ display: "none" }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const emailForm = document.getElementById("email-form");
                  if (emailForm) {
                    emailForm.style.display = "none";
                  }
                  // Show success notification
                  const notification = document.createElement("div");
                  notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white ${
                    isDarkMode ? "bg-green-600" : "bg-green-500"
                  } shadow-lg transition-opacity duration-500`;
                  notification.innerHTML =
                    '<i class="fas fa-check-circle mr-2"></i>Email envoyé avec succès';
                  document.body.appendChild(notification);
                  setTimeout(() => {
                    notification.style.opacity = "0";
                    setTimeout(() => notification.remove(), 500);
                  }, 3000);
                }}
              >
                <div className="space-y-4">
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Email du destinataire
                    </label>
                    <input
                      type="email"
                      defaultValue="parent@email.com"
                      required
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Objet
                    </label>
                    <input
                      type="text"
                      defaultValue={`Reçu de paiement - ${selectedPayment?.type}`}
                      required
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Message
                    </label>
                    <textarea
                      defaultValue={`Bonjour,\n\nVeuillez trouver ci-joint le reçu de paiement pour ${selectedPayment?.type} de ${selectedPayment?.eleve}.\n\nCordialement,\nEduGest`}
                      required
                      rows={4}
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                  </div>
                </div>
                <div className="mt-4 flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => {
                      const emailForm = document.getElementById("email-form");
                      if (emailForm) {
                        emailForm.style.display = "none";
                      }
                    }}
                    className={`px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-gray-700 hover:bg-gray-600"
                        : "bg-gray-200 hover:bg-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Annuler
                  </button>
                  <button
                    type="submit"
                    className={`px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white !rounded-button whitespace-nowrap`}
                  >
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Payment;
